// extracted by mini-css-extract-plugin
module.exports = {"main-component":"confetti_main-component__3nvjX"};